import React from "react"

import styles from "./IconListItem.module.scss"

const IconListItem = ({ children, icon }) => {
  return (
    <li className={styles.item}>
      {icon && (
        <div className={styles.icon}>
          <img src={`/media/svg/${icon}.svg`} alt="" />
        </div>
      )}
      <div>{children}</div>
    </li>
  )
}

export default IconListItem
